import { render, staticRenderFns } from "./confirmMobileOrEmail.vue?vue&type=template&id=e36f2982&scoped=true"
import script from "./confirmMobileOrEmail.vue?vue&type=script&lang=js"
export * from "./confirmMobileOrEmail.vue?vue&type=script&lang=js"
import style0 from "./confirmMobileOrEmail.vue?vue&type=style&index=0&id=e36f2982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36f2982",
  null
  
)

export default component.exports